import http from '../../Common/api';
import generateQueryParamsUrl from '../../Common/utils/queryParamsGenerator';

import { visitsUrl, partnersUrl, aggregatorsUrl, agenciesUrl, visitsDetailsUrl } from './constants';
import {
  normalizeVisits,
  normalizePartners,
  normalizeAggregators,
  normalizeAgencies,
  normalizeVisitsDetails,
  normalizeVisitReportsError,
} from './normalizers';

const getVisitReports = async (filters = {}) => {
  try {
    const searchBy = generateQueryParamsUrl(visitsUrl, filters);
    const visitsReports = await http.get(searchBy);

    return normalizeVisits(visitsReports);
  } catch (error) {
    return normalizeVisitReportsError(error);
  }
};

const getVisitsDetails = async visitID => {
  try {
    const visitDetails = await http.get(`${visitsDetailsUrl}${visitID}/`);

    return normalizeVisitsDetails(visitDetails);
  } catch {
    return normalizeVisitsDetails();
  }
};

const getPartners = async () => {
  try {
    const partners = await http.get(partnersUrl);

    return normalizePartners(partners);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getAggregators = async () => {
  try {
    const aggregators = await http.get(aggregatorsUrl);

    return normalizeAggregators(aggregators);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getAgencies = async ({ filters = {} }) => {
  try {
    const searchBy = generateQueryParamsUrl(agenciesUrl, { ...filters, active: true });
    const agencies = await http.get(searchBy);

    return normalizeAgencies(agencies);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getVisitFilterOptions = async () =>
  Promise.all([getPartners(), getAggregators(), getAgencies({})]);

export { getVisitReports, getVisitFilterOptions, getVisitsDetails, getAgencies };
